var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialTelegram28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.128 13.291s8.138-3.427 10.96-4.634c1.082-.483 4.751-2.028 4.751-2.028s1.694-.675 1.553.966c-.047.676-.424 3.041-.8 5.6-.564 3.62-1.176 7.58-1.176 7.58s-.094 1.11-.894 1.303c-.8.193-2.116-.676-2.352-.87-.188-.144-3.528-2.317-4.75-3.379-.33-.29-.706-.869.046-1.544a181.604 181.604 0 0 0 4.94-4.828c.564-.58 1.129-1.931-1.223-.29-3.34 2.366-6.633 4.587-6.633 4.587s-.753.482-2.164.048a96.177 96.177 0 0 1-3.058-1.014s-1.128-.724.8-1.497Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTelegram28);
export default __webpack_public_path__ + "static/media/social-telegram_28.54cb0378.svg";
export { ForwardRef as ReactComponent };